const routes = [
    {
        path: '/',
        component: () =>
            import(/* webpackChunkName: "appLayout" */ '@/layout/AuthLayout'),
        redirect: '/login',
        children: [
            {
                path: '/login',
                name: 'login',
                component: () =>
                    import(/* webpackChunkName: "login" */ '@/views/Login.vue')
            },
            {
                path: '/privacy-and-policy',
                name: 'privacyAndPolicyEn',
                component: () =>
                    import(
                    /* webpackChunkName: "privacyAndPolicyEn" */ '@/views/PrivacyAndPolicy.vue'
                    )
            }
        ]
    },
    {
        path: '/app',
        component: () =>
            import(/* webpackChunkName: "appLayout" */ '@/layout/AppLayout'),
        redirect: '/app/home',
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: 'home',
                name: 'home',
                component: () =>
                    import(/* webpackChunkName: "home" */ '@/views/Home.vue')
            },
            {
                path: 'recordings',
                name: 'recordings',
                component: () =>
                    import(/* webpackChunkName: "RecordingsList" */ '@/views/recordings/FileList.vue')
            },
            {
                path: 'recordings/new',
                name: 'recordings.new',
                component: () =>
                    import(
                    /* webpackChunkName: "pageNew" */ '@/views/recordings/EditForm.vue'
                    )
            },
            {
                path: 'recordings/edit/:audioId',
                name: 'recordings.edit',
                component: () =>
                    import(
                    /* webpackChunkName: "EditForm" */ '@/views/recordings/EditForm.vue'
                    )
            },
            // {
            //     path: 'qalon',
            //     name: 'qalon',
            //     component: () =>
            //         import(/* webpackChunkName: "RecordingsList" */ '@/views/qalon/FileList.vue')
            // },
            // {
            //     path: 'qalon/new',
            //     name: 'qalon.new',
            //     component: () =>
            //         import(
            //         /* webpackChunkName: "pageNew" */ '@/views/qalon/EditForm.vue'
            //         )
            // },
            // {
            //     path: 'qalon/edit/:audioId',
            //     name: 'qalon.edit',
            //     component: () =>
            //         import(
            //         /* webpackChunkName: "EditForm" */ '@/views/qalon/EditForm.vue'
            //         )
            // },
            {
                path: 'kids',
                name: 'kids',
                component: () =>
                    import(/* webpackChunkName: "RecordingsList" */ '@/views/kids/FileList.vue')
            },
            {
                path: 'kids/new',
                name: 'kids.new',
                component: () =>
                    import(
                    /* webpackChunkName: "pageNew" */ '@/views/kids/EditForm.vue'
                    )
            },
            {
                path: 'kids/edit/:audioId',
                name: 'kids.edit',
                component: () =>
                    import(
                    /* webpackChunkName: "EditForm" */ '@/views/kids/EditForm.vue'
                    )
            },
            {
                path: 'other-narrations',
                name: 'other-narrations',
                component: () =>
                    import(/* webpackChunkName: "RecordingsList" */ '@/views/otherNarrations/FileList.vue')
            },
            {
                path: 'other-narrations/new',
                name: 'other-narrations.new',
                component: () =>
                    import(
                    /* webpackChunkName: "pageNew" */ '@/views/otherNarrations/EditForm.vue'
                    )
            },
            {
                path: 'other-narrations/edit/:audioId',
                name: 'other-narrations.edit',
                component: () =>
                    import(
                    /* webpackChunkName: "EditForm" */ '@/views/otherNarrations/EditForm.vue'
                    )
            },
        ]
    },
    {
        path: '*',
        component: () =>
            import(/* webpackChunkName: "appLayout" */ '@/layout/AuthLayout'),
        children: [
            {
                name: '404 Error',
                path: '',
                component: () =>
                    import(/* webpackChunkName: "404-error" */ '@/views/Error')
            }
        ]
    }
];

export default routes;
